import { IConsultantBarometerKPIResult } from './KPIContract';
import { Link } from './CommonContract';

export interface IAggregateResult {
    items: IAggregateResultItem[];
}

export interface IAggregateResultItem {
    itemName: string;
    itemId: string;
    kpi: IConsultantBarometerKPIResult;
}

export interface IAggregateResultHypermediaRepresentation {
    items: IAggregateResultItemHypermediaRepresentation[];
}

export interface IAggregateResultItemHypermediaRepresentation {
    itemName: string;
    itemId: string;
    kpi: IConsultantBarometerKPIResult;
    _links: {
        item_people_actions: Link;
        item_evolution: Link;
        item_people_export: Link;
        item_members_without_barometer: Link;
    };
}

export enum AggregateType {
    Tribe = 'tribe',
    Hive = 'hive',
    Sector = 'sector',
    Account = 'account',
    All = 'all',
    Recent = 'recent'
}
